import { createAction, props } from '@ngrx/store';
import { ILoginData, ILoginModel, IOtpData, IOtpModel } from '@partners/api';

export class AuthActions {
  static resetGuide = createAction('[Auth][Guide] Reset State');
  static loadGuide = createAction('[Auth][Guide] Load');
  static loadGuideSuccess = createAction('[Auth][Guide] Load Success');
  static loadGuideFailure = createAction('[Auth][Guide] Load Failure', props<{ error: any }>());
  static submitGuide = createAction('[Auth][Guide] Submit');
  static submitGuideSuccess = createAction('[Auth][Guide] Submit Success');
  static submitGuideFailure = createAction('[Auth][Guide] Submit Failure', props<{ error: any }>());

  static resetOtp = createAction('[Auth][Otp] Reset State');
  static incOtpSendAttemptCount = createAction('[Auth][Login] Increment Otp Send Attempt Count');
  static updateOtpModel = createAction('[Auth][Otp] Update Model', props<{ model: IOtpModel }>());
  static loadOtp = createAction('[Auth][Otp] Load');
  static loadOtpSuccess = createAction('[Auth][Otp] Load Success', props<{ model: IOtpModel; data: IOtpData }>());
  static loadOtpFailure = createAction('[Auth][Otp] Load Failure', props<{ error: any }>());

  static submitOtp = createAction('[Auth][Otp] Submit', props<{ model: IOtpModel }>());
  static submitOtpSuccess = createAction('[Auth][Otp] Submit Success', props<{ data: IOtpData }>());
  static submitOtpFailure = createAction('[Auth][Otp] Submit Failure', props<{ error: any }>());

  static resetLogin = createAction('[Auth][Login] Reset State');

  static loadLogin = createAction('[Auth][Login] Load');
  static loadLoginSuccess = createAction(
    '[Auth][Login] Load Success',
    props<{ model: ILoginModel; data: ILoginData }>()
  );
  static loadLoginFailure = createAction('[Auth][Login] Load Failure', props<{ error: any }>());
  static submitLogin = createAction('[Auth][Login] Submit', props<{ model: ILoginModel }>());
  static submitLoginSuccess = createAction('[Auth][Login] Submit Success', props<{ data: ILoginData }>());
  static submitLoginFailure = createAction('[Auth][Otp] Submit Failure', props<{ error: any }>());
}
